module.exports = __webpack_public_path__ + "media/images/posts/plan_budget-3671f0f8cbf2270c454b6ec0b50faf03.jpg";